export var ThermometerState;
(function (ThermometerState) {
    ThermometerState["not_connected"] = "not_connected";
    ThermometerState["malfunction"] = "malfunction";
    ThermometerState["disconnected"] = "disconnected";
    ThermometerState["ok"] = "ok";
})(ThermometerState || (ThermometerState = {}));
